

/*import { createToaster } from "@meforma/vue-toaster";*/
import axiosInstance from "./api";
/*import TokenService from "./token.service";*/
//const privateEnvVar = import.meta.env.SERVER_SIDE_ONLY_VAR;

//const setup = (store) => {
//    axiosInstance.interceptors.request.use(
//        (config) => {
//            const token = localStorage.getItem("access_token"); //TokenService.getLocalAccessToken();
//            // alert(privateEnvVar);
//            if (token != null) {
//                if (config["Content-Type"] == "multipart/form-data") {
//                    config.headers["Content-Type"] = "multipart/form-data";
//                } else {
//                    config.headers["Content-Type"] = "application/json";
//                }
//                config.headers['Access-Control-Allow-Origin'] = '*',
//                    config.headers['Access-Control-Allow-Methods'] = 'GET,POST, PATCH,PUT,DELETE,OPTIONS',
//                    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token Origin,X-Requested-With,Accept',
//                    config.headers['Cache-Control'] = 'no-cache,no-store',//, no-store, must-revalidate, post-check=0, pre-check=0',
//                    config.headers['Pragma'] = 'no-cache',
//                    config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT',
//                    config.headers['If-Modified-Since'] = '0',
//                    config.headers['Access-Control-Max-Age'] = "3600"
//                    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem("access_token")



//            }
//            else {

//                config.headers["Content-Type"] = "application/json",
//                    config.headers['Access-Control-Allow-Origin'] = '*',
//                    config.headers['Access-Control-Allow-Methods'] = 'GET,POST, PATCH,PUT,DELETE,OPTIONS',
//                    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token',
//                    config.headers['Cache-Control'] = 'no-cache,no-store',//, no-store, must-revalidate, post-check=0, pre-check=0',
//                    config.headers['Pragma'] = 'no-cache',
//                    config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT',
//                    config.headers['If-Modified-Since'] = '0',
//                    config.headers['Access-Control-Max-Age'] = "3600"
//                    config.headers['Authorization'] = 'Bearer ' + ""

//            }
//            return config;
//        },
//        (error) => {
//            console.log("intercepter_Request", error.message);
//            return Promise.reject(error);
//        }
//    );


    const setup = (store) => {
        axiosInstance.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("access_token");

                // Set Content-Type based on whether the token is present
                config.headers["Content-Type"] = config["Content-Type"] === "multipart/form-data"
                    ? "multipart/form-data"
                    : "application/json";

                // Common headers
                config.headers['Access-Control-Allow-Origin'] = '*';
                config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS';
                config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token, X-Requested-With, Accept';
                config.headers['Cache-Control'] = 'no-cache, no-store';
                config.headers['Pragma'] = 'no-cache';
                config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT';
                config.headers['If-Modified-Since'] = '0';
                config.headers['Access-Control-Max-Age'] = "3600";

                // Set Authorization header if token exists
                config.headers['Authorization'] = token ? `Bearer ${token}` : '';

                return config;
            },
            (error) => {
                console.log("interceptor_Request", error.message);
                return Promise.reject(error);
            }
        );
    };

    //axiosInstance.interceptors.response.use(
    //    (res) => {
    //        return res;
    //    },
    //    async (err) => {
    //        const originalConfig = err.config;

    //        if (originalConfig.url !== "/auth/signin" && err.response) {
    //            // Access Token was expired
    //            if (err.response.status === 401 && !originalConfig._retry) {
    //                originalConfig._retry = true;

    //                try {
    //                    const rs = await axiosInstance.post("/auth/refreshtoken", {
    //                        refreshToken: localStorage.getItem("access_token"),
    //                    });

    //                    const { accessToken } = rs.data;

    //                    store.dispatch('auth/refreshToken', accessToken);


    //                    return axiosInstance(originalConfig);
    //                } catch (_error) {
    //                    console.log("intercepter_Response", _error);
    //                    return Promise.reject(_error);
    //                }
    //            }
    //        }

    //        return Promise.reject(err);
    //    }
    //);

axiosInstance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        // Check if the error is not related to the signin endpoint
        if (originalConfig.url !== "/auth/signin" && err.response) {
            // Handle token expiration
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const refreshToken = localStorage.getItem("refresh_token"); // Use refresh token here
                    const response = await axiosInstance.post("/auth/refreshtoken", {
                        refreshToken,
                    });

                    const { accessToken } = response.data;

                    // Dispatch the new access token to the store
                    store.dispatch('auth/refreshToken', accessToken);

                    // Update the original request's Authorization header
                    originalConfig.headers['Authorization'] = `Bearer ${accessToken}`;

                    // Retry the original request
                    return axiosInstance(originalConfig);
                } catch (error) {
                    console.log("interceptor_Response", error);
                    return Promise.reject(error);
                }
            }
        }

        return Promise.reject(err);
    }
);

//};

export default setup;